export default __webpack_public_path__ + "media/images/payments/mastercard-1-4689e38acca44ea69d879a3ea502647f.svg";